export const focusOnEvent = new Event("rnib:focuson", {
  bubbles: true,
  cancelable: true,
});
export const focusOutEvent = new Event("rnib:focusout", {
  bubbles: true,
  cancelable: true,
});
export const clickEvent = new Event("rnib:click", {
  bubbles: true,
  cancelable: true,
});
export const refocusEvent = new Event("rnib:refocus", {
  bubbles: true,
  cancelable: true,
});

export const endTaskEvent = () => {
  const event = new Event("rnib:end-task", {
    bubbles: true,
    cancelable: true,
  });
  document?.dispatchEvent(event);
};

export const continueTaskEvent = () => {
  const event = new Event("rnib:continue-task", {
    bubbles: true,
    cancelable: true,
  });
  document?.dispatchEvent(event);
};

export const setEyeConditionEvent = (
  eyeCondition: string,
  severityLevel: number
) => {
  const event = new CustomEvent("rnib:condition", {
    detail: {
      condition: eyeCondition,
      severity: severityLevel,
    },
  });
  document?.dispatchEvent(event);
};


